<template>
  <div class="main_box" v-loading="loading">
    <!--  -->
    <template v-if="list">
      <!-- list:{{ list }} -->
      <el-alert v-if="list.PlanSRResultStatus == 6&& list.IsReturn == 1"
        title="After checking the return, click ‘Confirm Refund’. Contact Us for issues." :closable="false"
        type="warning" show-icon></el-alert>
      <div>
        <b>Case Outcome:</b>
        <span class="text_yellow">
          <span>Close order</span> /
          <span
            v-if="(list.PlanSRResultStatus == 6 && list.IsReturn == 0) || (list.PlanSRResultStatus == 9 && list.IsReturn == 0)">Refund</span>
          <span
            v-if="list.PlanSRResultStatus > 6 || ((list.PlanSRResultStatus == 9 || list.PlanSRResultStatus == 6) && list.IsReturn == 1)">Returns
            &
            Refunds</span>
        </span>
      </div>
      <!-- 退款退货标题 -->
      <div>
        <div class="flex items-center">
          <h3 class="flex_1 text_yellow" v-if="list.PlanSRResultStatus == 6 && list.IsReturn == 0">Wait Refund</h3>
          <h3 class="flex_1 text_yellow" v-if="list.PlanSRResultStatus == 7">Fill Return Address</h3>
          <h3 class="flex_1 text_yellow"
            v-if="list.PlanSRResultStatus == 8 || (list.PlanSRResultStatus == 6 && list.IsReturn == 1)">Wait Buyer Return
          </h3>
          <h3 class="flex_1 text_yellow" v-if="list.PlanSRResultStatus == 9">Refunded</h3>
          <div class="flex items-center outcome_operate">
            <div class="ContactSeller flex items-center">
              <el-avatar class="user_img" :size="16" :src="list.HeadPortrait + $store.state.thumbnail"></el-avatar>
              <a class="btns" target="_blank"
                :href="`${$store.getters.CHAT(list.SellMemberId)}&type=${$store.state.Chat.OrderType}&id=${list.OrderId}`">
                {{ list.RealName }}
                <i class="member_source" v-if="list.BuyerMemberSource == 'CN'">{{ list.BuyerMemberSource }}</i>
              </a>&nbsp;({{ parseInt(list.BuyerIntegral) }})
            </div>
            <!-- 退款 -->
            <div v-if="(list.PlanSRResultStatus == 6) || (list.PlanSRResultStatus == 8 && list.SendExpress)">
              <el-button type="primary" @click="refundPrice()">Refund {{ list.SellRealMoneyUnit }} {{ list.RebackMoney
                }}</el-button>
            </div>
            <!-- 提交退货地址 -->
            <div v-if="list.PlanSRResultStatus == 7">
              <el-button type="primary" @click="saveAddress('passForm', true)">Confirm Return Address</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 退款退货详情 -->
      <div>
        <ul id="detail">
          <li class="flex table_head">
            <div class="flex_1">Item</div>
            <div class="align_right w_12">Refund</div>
            <div class="align_right w_12">Shipping Fee</div>
            <div class="align_right w_12">Refund Amount</div>
          </li>
          <li class="flex p_8">
            <div class="flex_1">
              <div class="flex_1 flex item_detail" v-for="(item, index) in list.OrderDetails" :key="index">
                <div class="flex_1 flex">
                  <div>
                    <el-image class="like_img" :src="item.TitImg + '?imageView2/2/w/200'" fit="contain"></el-image>
                  </div>
                  <p class="line_txt3 flex_1 px_12">{{ item.Title }}</p>
                </div>
                <div class="align_right w_12">{{ list.SellRealMoneyUnit }} {{ item.RefundMoney }}</div>
              </div>
            </div>
            <div class="align_right w_12">{{ list.SellRealMoneyUnit }} {{ list.RefundPostage }}</div>
            <div class="align_right w_12">{{ list.SellRealMoneyUnit }} {{ list.RebackMoney }}</div>
          </li>
        </ul>
      </div>
      <!-- 退货/退款加快递 -->
      <template v-if="list.PlanSRResultStatus >= 6 && list.IsReturn">
        <!-- 退货 -->
        <div class="return_box">
          <div class="flex items-center">
            <span class="text_2xl">Return Address</span>
            <!-- v-if="list.PlanSRResultStatus==7" -->
            <span class="icon_edit icon_text el-icon-edit" v-if="list.PlanSRResultStatus == 7"
              @click="isAdd = !isAdd">edit</span>
          </div>
          <div class="icon_text icon_address px_12"
            v-if="(list.PlanSRResultStatus == 8 || list.PlanSRResultStatus == 9) || (!isAdd && passForm.StreetAddress)">
            <p>
              <span class="comma">{{ passForm.StreetAddress }}</span>
              <span class="comma">{{ passForm.StreetAddress2 }}</span>
              <span class="comma">{{ passForm.City }}</span>
              <span class="comma">{{ passForm.State }}</span>
              <span class="comma">{{ passForm.ZipCode }}</span>
            </p>
            <p>
              {{ passForm.UserName }}({{ passForm.Country }}) {{ passForm.Phone }}
            </p>
          </div>
          <!-- 编辑地址 v-if="isAdd"-->
          <div v-show="isAdd">
            <el-form :model="passForm" :rules="passRules" ref="passForm" :hide-required-asterisk='true'
              label-position="top" class="set_form">
              <div class="address_box country">
                <el-form-item :label="$t('colon.country')" class="info_box" prop="Country">
                  <el-input class="info_ipt" v-model="passForm.Country" :disabled="true"></el-input>
                </el-form-item>
              </div>
              <div class="address_box">
                <el-form-item :label="$t('colon.name')" class="info_box" prop="UserName">
                  <el-input class="info_ipt" v-model="passForm.UserName"></el-input>
                </el-form-item>
              </div>
              <div class="address_box">
                <el-form-item :label="$t('colon.street1')" class="info_box" prop="StreetAddress">
                  <el-input class="info_ipt" v-model="passForm.StreetAddress"></el-input>
                </el-form-item>
                <el-form-item :label="$t('colon.street2')" class="info_box" prop="StreetAddress2">
                  <el-input class="info_ipt" v-model="passForm.StreetAddress2"></el-input>
                </el-form-item>
              </div>
              <div class="address_box">
                <el-form-item :label="$t('colon.city')" class="info_box" prop="City">
                  <el-input class="info_ipt" v-model="passForm.City"></el-input>
                </el-form-item>
                <el-form-item :label="$t('colon.state')" class="info_box" prop="State">
                  <el-select v-model="passForm.State" filterable class="info_ipt"
                    :placeholder="$t('rules.selectState')">
                    <el-option :label="item.EName" :value="item.EName" v-for="(item, index) in getAreas"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="address_box">
                <el-form-item :label="$t('colon.zipCode')" class="info_box" prop="ZipCode">
                  <el-input class="info_ipt" v-model="passForm.ZipCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('colon.phone')" class="info_box" prop="Phone">
                  <el-input class="info_ipt" v-model="passForm.Phone"></el-input>
                </el-form-item>
              </div>
              <div class="set_btn">
                <el-button @click="resetForm('passForm')">{{ $t('button.cancel') }}</el-button>
                <el-button @click="saveAddress('passForm')">{{ $t('button.save') }}</el-button>
              </div>
            </el-form>
          </div>
        </div>
        <!-- 快递 -->
        <div class="return_box" v-if="list.SendExpress">
          <div class="flex items-center">
            <span class="text_2xl">Return Tracking Details</span>
          </div>
          <div class="icon_text icon_express px_12">
            <p>{{ list.SendExpressName }} {{ list.SendExpress }}</p>
          </div>
        </div>
      </template>
      <!-- 友情提示 -->
      <!-- <div>
        <el-alert title="If the seller doesn't process it, Card Hobby will issue the refund." :closable="false"
          type="info" show-icon></el-alert>
      </div> -->
    </template>
  </div>
</template>

<script>

export default {
  name: "",
  components: {},
  data() {
    var isChinese = (rule, value, callback) => {
      let msg = this.$t('rules.enterAddress')
      if (value == '' && rule.field == 'StreetAddress') {
        callback(new Error(msg));
      }
      let Country = ''
      if (this.userInfo) {
        Country = this.userInfo.MemberSource
      }
      let isChinese = 'HK,TWN,MO,CN'
      if (isChinese.indexOf(Country) > -1) {
        let text = this.passForm.StreetAddress + this.passForm.StreetAddress2
        let reg = /[\u4E00-\u9FA5]/g;
        let ChineseLength = (text.match(reg) || []).length
        if (ChineseLength < 4) {
          msg = this.$t('rules.isChinese')
          callback(new Error(msg));
        }
        setTimeout(() => {
          if (rule.field == 'StreetAddress') {
            if (ChineseLength < 4) {
              this.$refs['passForm'].validateField('StreetAddress2')
            }
          }
          if (rule.field == 'StreetAddress2') {
            this.$refs['passForm'].validateField('StreetAddress')
          }
        })
      }
      callback();
    }
    return {
      loading: false,
      orderId: '',
      userInfo: this.$store.state.UserInfo,
      list: '',
      USDRate: '',
      getAreas: '',
      isAdd: false,
      passForm: {
        Country: '',
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        State: '',
        ZipCode: '',
        Phone: '',
      },
      passRules: {
        Country: [
          { required: true, message: this.$t('rules.enterCountry'), trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: this.$t('rules.enterName'), trigger: 'blur' }
        ],
        StreetAddress: [
          { validator: isChinese, trigger: 'blur' },
        ],
        StreetAddress2: [
          { validator: isChinese, trigger: 'blur' },
        ],
        City: [
          { required: true, message: this.$t('rules.enterCity'), trigger: 'blur' }
        ],
        State: [
          { required: true, message: this.$t('rules.selectState'), trigger: 'change' }
        ],
        ZipCode: [
          { required: true, message: this.$t('rules.enterZipCode'), trigger: 'blur' }
        ],
        Phone: [
          { required: true, message: this.$t('rules.enterPhone'), trigger: 'blur' }
        ]
      }
    };
  },
  created: function () {
    this.orderId = this.$route.params.id
    this.getOrderDetail(this.orderId)
  },
  mounted() {
    this.passForm.Country = this.userInfo.MemberSource
    this.getAddress()
  },
  watch: {
  },
  computed: {

  },
  methods: {
    /**
     * 退款确认操作
     * 弹出确认框询问用户是否确认退款，确认后调用退款接口
     * @function refundPrice
     * @returns {void}
     */
    refundPrice() {
      let that = this
      let html = `<div class="p_txt">Confirm Refund USD ${that.list.RebackMoney}?</div>`
      that.$confirm(html, 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        dangerouslyUseHTMLString: true
      }).then(() => {
        let data = { OrderID: that.orderId }
        that.loading = true
        that.$post('ConfirmPlanSRResult', data).then(res => {
          if (res.result) {
            that.getPlanSRResult()
          }else{
            that.loading = false
          }
        })
      }).catch(() => {
      });
    },

    /**
     * 保存地址信息
     * @param {string} formName - 表单ref名称
     * @param {boolean} type - 操作类型标识(true表示保存地址，false表示取消)
     * @description 验证表单并提交地址信息到服务器，成功后刷新数据或关闭地址编辑状态
     */
    saveAddress(formName, type) {
      let that = this
      console.log(that.$refs[formName],'that.$refs[formName]')
      that.$refs[formName].validate((valid,callback) => {
        if (valid) {
          if (type) {
            let address = that.passForm.StreetAddress
            if (that.passForm.StreetAddress2) {
              address += '(' + that.passForm.StreetAddress2 + ')'
            }
            let data = {
              OrderID: that.orderId,
              Consignee: that.passForm.UserName,
              Mobile: that.passForm.Phone,
              ZipCode: that.passForm.ZipCode,
              Nation: that.passForm.Country,
              Provice: that.passForm.State,
              City:that.passForm.City,
              Address: address,
            }
            that.loading = true
            console.log(data, 'data')
            that.$post('ModityPlanSRResultAddress', data).then(res => {
              console.log(res, 'res')
              if (res.result) {
                that.isAdd = false
                that.getPlanSRResult()
              }
            })
          } else {
            that.isAdd = false
          }
        }else{
          try{
            that.$message({
              message:Object.values(callback)[0][0].message,
              type: 'error'
            });
          }catch(e){}
        }
      })
    },
    /**
     * 重置表单数据
     * @param {string} formName - 表单ref名称
     */
    resetForm(formName) {
      let that = this
      //that.$refs[formName].resetFields();
      that.isAdd = false
    },
    /**
     * 获取用户地址信息
     * 根据用户会员来源编码请求地址数据
     * @returns {void} 无返回值，获取结果直接赋值给组件的getAreas属性
     */
    getAddress() {
      let that = this
      let data = `?code=${that.userInfo.MemberSource}`
      that.$get('GetAreasByCode', data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
        }
      })
    },
    /**
     * 获取订单详情
     * @param {string} id - 订单ID
     * @description 根据订单ID获取订单详细信息，包括美元汇率、买家信息等
     * @returns {Promise} 返回包含订单详情的Promise对象
     */
    getOrderDetail(id) {
      let that = this
      let data = `?OrderID=${id}`
      that.loading = true
      that.$get('OrderDetail', data).then(res => {
        if (res.result) {
          let result = res.data
          that.USDRate = {
            USDRate: result.USDRate,
            SellRealMoneyUnit: 'USD',
            BuyerMemberSource: result.BuyerMemberSource,
            RealName: result.BuyerName,
            BuyerIntegral: result.BuyerIntegral,
            HeadPortrait: result.BuyerHeadPortrait
          }
          that.getPlanSRResult()
        }
      })
    },
    //获取预处理详情
    /**
     * 获取预处理详情
     * 通过订单ID获取预处理详情数据
     * 1. 设置汇率数据
     * 2. 如果是退货情况则设置退货地址
     * 3. 最后关闭加载状态
     */
    getPlanSRResult() {
      let that = this
      let data = `?OrderID=${that.orderId}`
      that.$get('GetPlanSRResultByOrderId', data).then(res => {
        if (res.result) {
          let result = res.data
          let oldResult = that.USDRate
          that.setRate(result, oldResult)
          if(result.PlanSRResultStatus==7){
            that.getPlanSRAddressEdit()
          }else{
            that.setAddress(result)
          }
        }
        that.loading = false
      })
    },
    /**
     * 获取并设置会员地址信息
     * 通过会员ID获取地址信息，并将结果设置到组件状态中
     * @returns {void}
     */
    getPlanSRAddressEdit(){
      let that=this
      let data = `?MemberID=${that.userInfo.MappingUserId}`
      that.$get('PlanSRAddressEdit', data).then(res => {
        if(res.result){
          if(res.data.Provice){
            var result={SellMemberAddress:res.data}
            that.setAddress(result)
          }
        }
      })
    },
    /**
     * 设置汇率转换后的金额
     * @param {Object} result - 当前结果对象
     * @param {Object} oldResult - 包含汇率信息的旧结果对象
     * @description 将result对象中的各项金额(oldResult.USDRate)进行汇率转换并保留2位小数，
     *              同时处理OrderDetails数组中的RefundMoney字段，最后合并新旧结果
     */
    setRate(result, oldResult) {
      let that = this
      result.RefundMoney = that.$store.getters.numMulti(result.RefundMoney, oldResult.USDRate).toFixed(2)
      result.RefundPostage = that.$store.getters.numMulti(result.RefundPostage, oldResult.USDRate).toFixed(2)
      result.ServiceAndTaxRefund = that.$store.getters.numMulti(result.ServiceAndTaxRefund, oldResult.USDRate).toFixed(2)
      result.RebackMoney = that.$store.getters.numMulti(result.RebackMoney, oldResult.USDRate).toFixed(2)
      result.OrderDetails.map(item => {
        item.RefundMoney = that.$store.getters.numMulti(item.RefundMoney, oldResult.USDRate).toFixed(2)
      })
      that.list = Object.assign({}, oldResult, result)
    },
    /**
     * 设置地址信息
     * @param {Object} result - 包含地址信息的对象
     * @description 
     * 1. 处理省份/州信息，支持带"-"分隔的格式
     * 2. 处理地址字符串，清理特殊字符并分割为街道地址和地址行2
     * 3. 将处理后的地址信息赋值给表单对象
     * @throws 捕获并打印可能的异常
     */
    setAddress(result) {
      let that = this
      try {
        let address = result.SellMemberAddress.Address
        if (address.indexOf('()') > 0) {
          // var a=add1.indexOf('()')
          // console.log(add1,a,'add2',add1.substring(0,a))
          //var reg=new RegExp()
          address = address.replace(/\(\)/g, "")
          //console.log(add1,a,'add1')
          address = [address]
        } else {
          if (address.indexOf(')') != -1) {
            address = address.replace(")", "")
            address = address.replace("(", "|")
          }
          address = address.split("|")
        }
        that.passForm.Country = result.SellMemberAddress.Nation
        that.passForm.UserName = result.SellMemberAddress.Consignee
        that.passForm.City = result.SellMemberAddress.City
        that.passForm.State = result.SellMemberAddress.Provice
        that.passForm.ZipCode = result.SellMemberAddress.ZipCode
        that.passForm.Phone = result.SellMemberAddress.Mobile
        that.passForm.StreetAddress = address[0]
        that.passForm.StreetAddress2 = address[1]
      } catch (e) {
        console.log(e)
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/orderlist.css";

.user_img {
  margin-right: 5px;
}

.ContactSeller a:hover {
  text-decoration: underline;
  color: #5f6dae
}

h3 {
  font-size: 24px;
}

.flex_1 {
  flex: 1
}

.items-center {
  align-items: center;
}

.align_right {
  text-align: right;
}

.text_2xl {
  font-size: 24px;
}

.p_8 {
  padding: 8px;
}

.px_12 {
  padding-left: 12px;
  padding-right: 12px
}

.w_12 {
  width: 12%;
}

.main_box>div+div {
  margin-top: 24px;
}

.outcome_operate>div+div {
  margin-left: 20px;
}

#detail .table_head {
  background-color: #f7f7f7;
  padding: 14px 8px;
  border-bottom: 0.5px solid #e0e0e0;
}

#detail .table_head>div:first-child {
  padding-left: 100px;
}

#detail>li+li {
  margin-top: 12px;
}

#detail>li>div+div {
  padding-left: 12px;
}

#detail .item_detail+.item_detail {
  margin-top: 10px;
}

.returnItemBtn {
  margin-left: 12px;
}

.icon_text {
  padding-left: 20px;
  position: relative;
}

.icon_text::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  min-height: 16px;
}

.icon_edit {
  padding-left: 18px;
  margin-left: 10px;
  color: #5F6DAE;
  cursor: pointer;
}

.icon_edit::before {
  content: "\E78C";
  color: #5F6DAE;

}

.icon_address::before {
  background: url(../../../static/images/icons/icon_address.svg) no-repeat;
  background-size: contain;
  height: 20px;
}

.icon_express::before {
  background: url(../../../static/images/icons/icon_car_blue.svg) 0 3px no-repeat;
  height: 20px;
}

.address_box {
  display: flex;
}

.address_box+.address_box {
  margin-top: 15px;
}

.address_box>div+div {
  margin-left: 20px;
}

.info_box {
  width: 300px;
}

.comma+.comma::before {
  content: ",";
  margin-right: 3px;
}

.return_box>div+div {
  margin-top: 15px;
}

.return_box+.return_box {
  margin-top: 30px;
}

/deep/ .info_box .el-select {
  width: 100%;
}

/deep/ .el-form-item__label {
  line-height: 1;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/outcome.vue